import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Autocomplete from "react-google-autocomplete";
import { setPlace } from '../../../Redux/Action/Action';
import restaurantsbg from '../../../assets/images/restaurants-bg.png'
import search from '../../../assets/images/search.svg'

export default function RestaurentBanner() {
    const place = useSelector((state) => state.place);
    const dispatch = useDispatch()
    const localSelectedCity = localStorage.getItem('selectedCity');
    return (
        <section className="section-equal-padding hotel-hero-sec"
            style={{ backgroundImage: `url(${restaurantsbg})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
             uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
            <div className="container">
                <div className="slider-content text-center mx-auto">
                    <h1>Restaurants</h1>
                </div>
                <div className="search-wrapper flight-search-wrpaaer bg-white d-block">
                    <div className="flight-booking-form">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="search-item">
                                    <label className="form-label">Search for a city or place</label>
                                    <div
                                        className="search-control-wrapper input-group custom-input d-flex align-items-center gap-2">
                                        <img src={search} alt="search" />
                                        <Autocomplete
                                            className="shadow-none border-0 form-control outline-0 p-0 px-2"
                                            apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                                            placeholder={
                                                localSelectedCity && localSelectedCity !== "undefined" && place
                                                    ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                                    : "Where would you like to go"
                                            }

                                            onPlaceSelected={async (city) => {
                                                const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                                                // // Dispatch Redux actions
                                                dispatch(setPlace(selectedCity));
                                                localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
